import { z } from 'my-zod'

export const ProgramTypeEnum = z
  .enum([
    'PolarisAdventures',
    'FleetSaleOnly',
    'IndianMotorcycleRentals',
    'Marine',
    'EmployeePolarisOwnedUnits',
    'Marketing',
    'Engineering',
    'SalesDemo',
    'InternalCheckout',
    'Test',
    'CorporateUnknown'
  ])
  .setEnumLabels({
    PolarisAdventures: 'Polaris Adventures',
    FleetSaleOnly: 'Fleet Sale Only',
    IndianMotorcycleRentals: 'Indian Motorcycle Rentals',
    Marine: 'Marine',
    EmployeePolarisOwnedUnits: 'Employee Polaris Owned Units',
    Marketing: 'Marketing',
    Engineering: 'Engineering',
    SalesDemo: 'Sales Demo',
    InternalCheckout: 'Internal Checkout',
    Test: 'Test',
    CorporateUnknown: 'Corporate (Unknown)' //this is only used when we try to automatically create a corp fleet vehicle but don't have the existing department in our system...should be very rare
  })

export type ProgramTypeEnum = z.infer<typeof ProgramTypeEnum>
export const ProgramTypeOptions = Object.values(ProgramTypeEnum.Values)

export const CorporateFleetProgramTypeEnum = z
  .enum(['Marketing', 'Engineering', 'SalesDemo', 'CorporateUnknown'])
  .setEnumLabels({
    Marketing: 'Marketing',
    Engineering: 'Engineering',
    SalesDemo: 'Sales Demo',
    CorporateUnknown: 'Corporate (Unknown)'
  })

export type CorporateFleetProgramTypeEnum = z.infer<typeof CorporateFleetProgramTypeEnum>
export const CorporateFleetProgramTypeOptions = Object.values(CorporateFleetProgramTypeEnum.Values)

export const EmployeePolarisOwnedUnitsProgramTypeEnum = z.enum(['EmployeePolarisOwnedUnits']).setEnumLabels({
  EmployeePolarisOwnedUnits: 'Employee Polaris Owned Units'
})

export type EmployeePolarisOwnedUnitsProgramTypeEnum = z.infer<typeof EmployeePolarisOwnedUnitsProgramTypeEnum>
export const EmployeePolarisOwnedUnitsProgramTypeOptions = Object.values(EmployeePolarisOwnedUnitsProgramTypeEnum.Values)

// These are specifically for the Vehicles service that is now really used just for these three use cases.
export const AdventuresVehicleProgramTypeEnum = z
  .enum(['FleetSaleOnly', 'IndianMotorcycleRentals', 'InternalCheckout', 'Marine', 'PolarisAdventures', 'Test'])
  .setEnumLabels({
    FleetSaleOnly: 'Fleet Sale Only',
    IndianMotorcycleRentals: 'Indian Motorcycle Rentals',
    InternalCheckout: 'Internal Checkout',
    Marine: 'Marine',
    PolarisAdventures: 'Polaris Adventures',
    Test: 'Test'
  })

export type AdventuresVehicleProgramTypeEnum = z.infer<typeof AdventuresVehicleProgramTypeEnum>
export const AdventuresVehicleProgramTypeOptions = Object.values(AdventuresVehicleProgramTypeEnum.Values)
